import React from "react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";

import { Modal } from "widgets/modal";
import { Timeline, UserIcon, AVATAR_SIZE } from "widgets/datadisplay";

import { Comment } from "./comment";

import styles from "../../forum/forum.css";

import CloseIcon from "../../common/icons/Close.svg";

export function Replies({
  topicId,
  isShowReplies,
  setShowReplies,
  values,
  teamId
}) {
  return (
    <Modal
      open={isShowReplies}
      closable={false}
      width="80rem"
      backgroundClassName={styles.repliesDrawer}
      footerRenderer={() => null}
    >
      <div className={styles.wrapper}>
        <div className={`${styles.header} ${styles.flexBox}`}>
          <div className={`${styles.left} h4-600`}>
            <Trans>Replies</Trans>
          </div>
          <div className={styles.right}>
            <span
              className={styles.closeIcon}
              onClick={(event) => {
                event.stopPropagation();
                setShowReplies();
              }}
            >
              <CloseIcon />
            </span>
          </div>
        </div>
        <div className={styles.body}>
          <Timeline
            values={values.map((value) => ({
              ...value,
              customIcon: (
                <UserIcon
                  userId={value?._created_by?._id}
                  name={value?._created_by?.Name}
                  size={AVATAR_SIZE.SIZE44}
                />
              )
            }))}
            className={styles.repliesTimeline}
            itemRenderer={(value) => (
              <Comment topicId={topicId} comment={value} teamId={teamId} />
            )}
          />
        </div>
      </div>
    </Modal>
  );
}

Replies.propTypes = {
  isShowReplies: PropTypes.bool,
  setShowReplies: PropTypes.func,
  values: PropTypes.array,
  teamId: PropTypes.string,
  topicId: PropTypes.string
};
